import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useScreens } from "../../../context/ScreenContext";
import UploadScreenComponent from "./Screens/UploadScreenComponent";
import ScreensListComponent from "./Screens/ScreensListComponent";
import { TagProvider } from "../../../context/TagContext";
import { GroupProvider } from "../../../context/GroupContext";

const Screens: React.FC = () => {
  const { screens } = useScreens();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/screens") {
      if (screens.length > 0) {
        navigate("/screens/list", { replace: true });
      } else {
        navigate("/screens/upload", { replace: true });
      }
    }
  }, [location.pathname, screens]);

  return (
    <GroupProvider>
      <TagProvider>
        <Routes>
          <Route path="/upload" element={<UploadScreenComponent />} />
          <Route path="/list" element={<ScreensListComponent />} />
        </Routes>
      </TagProvider>
    </GroupProvider>
  );
};

export default Screens;
